import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import emailSenderApi from '@/features/dashboard/emailSender/api/emailSenderApi.ts';
import { emailSenderApiQueryKeys } from '@/features/dashboard/emailSender/api/emailSenderApi.queryKeys.ts';
import { EmailSenderSettingsDto } from '@/features/dashboard/emailSender/types/EmailSenderSettingsDto.ts';

const useGetEmailSenderSettings = () => {
  return useQuery(getEmailSenderSettingsQueryOptions());
};

export const getEmailSenderSettingsQueryOptions =
  (): UseQueryOptions<EmailSenderSettingsDto> => ({
    queryKey: emailSenderApiQueryKeys.all(),
    queryFn: () => emailSenderApi.get(),
    staleTime: 1000 * 60,
  });

export default useGetEmailSenderSettings;
